import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './i-charge-roaming.css'

const IChargeRoaming = (props) => {
  return (
    <div className="i-charge-roaming-container1">
      <Helmet>
        <title>iChargeRoaming - Copy of iCharge web copy 2</title>
        <meta
          property="og:title"
          content="iChargeRoaming - Copy of iCharge web copy 2"
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/d8d38ac4-4f3e-47be-9087-cfeb299d0f93/a5b67eda-b5fa-4da5-98e7-80a54823e21a?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar
        homeLink1={
          <Fragment>
            <span className="i-charge-roaming-text10">
              View real-time charger availability, monitor your charging
              sessions, and more
            </span>
          </Fragment>
        }
        homeLink2={
          <Fragment>
            <span className="i-charge-roaming-text11">
              Discover one of the nation&apos;s largest public fast charging
              networks, powered by 100% renewable energy
            </span>
          </Fragment>
        }
        homeLink3={
          <Fragment>
            <span className="i-charge-roaming-text12">How to Charge</span>
          </Fragment>
        }
        homeLink4={
          <Fragment>
            <span className="i-charge-roaming-text13">
              Learn how to power up on the go and review our charging FAQs.
            </span>
          </Fragment>
        }
        homeLink5={
          <Fragment>
            <span className="i-charge-roaming-text14">
              Can&apos;t find what you&apos;re looking for? Let us help you.
            </span>
          </Fragment>
        }
        aboutLink1={
          <Fragment>
            <span className="i-charge-roaming-text15">
              From recycling to renewable energy, we&apos;re committed to
              protecting our environment.
            </span>
          </Fragment>
        }
        aboutLink2={
          <Fragment>
            <span className="i-charge-roaming-text16">
              Cultivating Connection
            </span>
          </Fragment>
        }
        supportLink1={
          <Fragment>
            <span className="i-charge-roaming-text17">
              <span>
                Whether you&apos;re a dedicated public charger or want to keep
                your options open,
              </span>
              <br></br>
              <span> iCharge has a plan for you.</span>
            </span>
          </Fragment>
        }
        supportLink2={
          <Fragment>
            <span className="i-charge-roaming-text21">How to charge</span>
          </Fragment>
        }
        chargingPointLink1={
          <Fragment>
            <span className="i-charge-roaming-text22">
              Can&apos;t find what you&apos;re looking for? Let us help you
            </span>
          </Fragment>
        }
        chargingPointLink2={
          <Fragment>
            <span className="i-charge-roaming-text23">
              Locate nearby charging points with the iCharge app and simplify
              your charging
            </span>
          </Fragment>
        }
      ></Navbar>
      <main className="column align-center full-width">
        <section className="i-charge-roaming-hero column align-center justify-center full-width thq-section-padding">
          <div className="i-charge-roaming-container2">
            <img
              alt="pastedImage"
              src="/Pages/Home/harta.svg"
              className="i-charge-roaming-pasted-image1"
            />
          </div>
          <div className="i-charge-roaming-max-width1 row full-width max-content-width">
            <div className="i-charge-roaming-right column gap-2-5">
              <div className="i-charge-roaming-container3">
                <h1 className="i-charge-roaming-text24 heading-1">iCharge</h1>
                <span className="i-charge-roaming-text25">Roaming</span>
              </div>
              <p className="i-charge-roaming-text26 sub-heading-2">
                iCharge Roaming allows you to charge your electric car on
                partner networks abroad, similar to mobile phone roaming.
              </p>
              <div className="i-charge-roaming-container4">
                <span className="i-charge-roaming-text27 sub-heading-2">
                  Where does it work?
                </span>
                <ul className="i-charge-roaming-ul list">
                  <li className="i-charge-roaming-li1 list-item">
                    <span className="i-charge-roaming-text28 sub-heading-2">
                      Neighboring countries: Italy, Montenegro, North Macedonia,
                      Greece
                    </span>
                  </li>
                  <li className="i-charge-roaming-li2 list-item">
                    <span className="i-charge-roaming-text29 sub-heading-2">
                      Other EU countries with connected networks
                    </span>
                  </li>
                  <li className="i-charge-roaming-li3 list-item">
                    <span className="i-charge-roaming-text30 sub-heading-2">
                      Partner stations appear in the app marked as “partner” or
                      “roaming”
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="i-charge-roaming-who-benefits column align-center justify-center full-width thq-section-padding">
          <div className="i-charge-roaming-max-width2 column align-center full-width max-content-width">
            <div className="row gap-6 full-width i-charge-roaming-cards-container">
              <div className="i-charge-roaming-container5 column align-center gap-6 flex-1">
                <img
                  alt="image"
                  sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                  src="/external/width_388-1500w.webp"
                  srcSet="/external//width_388-1500w.webp 1200w, /external/width_388-tablet.webp 800w, /external/width_388-mobile.webp 480w"
                  className="i-charge-roaming-image1"
                />
                <span className="i-charge-roaming-text31 sub-heading-2">
                  Ideal for travel and international fleets, roaming ensures a
                  seamless, easy, and technically hassle-free experience
                  wherever partner networks are available. iCharge is part of
                  European interoperability networks and is continuously
                  expanding coverage.
                </span>
              </div>
              <div className="i-charge-roaming-container6 column align-center gap-6 flex-1">
                <img
                  alt="image"
                  sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                  src="/external/p1290110-1500w.webp"
                  srcSet="/external//p1290110-1500w.webp 1200w, /external/p1290110-tablet.webp 800w, /external/p1290110-mobile.webp 480w"
                  className="i-charge-roaming-image2"
                />
                <span className="i-charge-roaming-text32 sub-heading-2">
                  Use iCharge Roaming easily: open the app, select a partner
                  station, and start charging—no extra apps or devices needed.
                  Payment is made from your iCharge balance, and prices are
                  displayed clearly before starting.
                </span>
              </div>
            </div>
          </div>
        </section>
        <section className="i-charge-roaming-integrating column align-center justify-center full-width thq-section-padding gap-8">
          <div className="column full-width gap-8 max-content-width i-charge-roaming-max-width3">
            <div className="i-charge-roaming-content column gap-5">
              <div className="column gap-5">
                <p className="i-charge-roaming-text33 sub-heading-2">
                  iCharge is part of European interoperability networks and is
                  continuously expanding coverage. All you need is an updated
                  app and an active balance – no additional setup is required.
                </p>
              </div>
            </div>
            <div className="i-charge-roaming-container8">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/external/width_800-1500w.webp"
                srcSet="/external//width_800-1500w.webp 1200w, /external/width_800-tablet.webp 800w, /external/width_800-mobile.webp 480w"
                className="i-charge-roaming-pasted-image2"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer rootClassName="footerroot-class-name9"></Footer>
    </div>
  )
}

export default IChargeRoaming
